import { create } from 'zustand';
import EstadoAdmin from '../types/EstadoAdmin';

const adminStore = create<EstadoAdmin>((set) => ({
    usuarioEmail: '',
    usuarioNombre: '',
    usuarioApellido: '',
    usuarioNivel: '',
    usuarioId: 0,
    usuarioCelular: '',
    seleccionActual: '',
    accionActual: '',
    setUsuarioEmail: (usuarioEmail: string) => set({ usuarioEmail }),
    setUsuarioNombre: (usuarioNombre: string) => set({ usuarioNombre }),
    setUsuarioApellido: (usuarioApellido: string) => set({ usuarioApellido }),
    setUsuarioNivel: (usuarioNivel: string) => set({ usuarioNivel }),
    setUsuarioId: (usuarioId: number) => set({ usuarioId }),
    setUsuarioCelular: (usuarioCelular: string) => set({ usuarioCelular }),
    setSeleccionActual: (seleccionActual: string) => set({ seleccionActual }),
    setAccionActual: (accionActual: string) => set({ accionActual }),
}));

export default adminStore;